import classNames from 'classnames';
import PropTypes from 'prop-types';

import { pastDateDisplay } from '../../../../../utils';

const ChatDate = function ChatDate({
  dtime,
  myMessage,
}) {
  return (
    <span
      className={classNames(
        'text-xs italic min-h-5 self-start text-txt-80',
        {
          'text-start': !myMessage,
          'text-end': myMessage,
        },
      )}
    >
      {pastDateDisplay(dtime)}
    </span>
  );
};

ChatDate.propTypes = {
  dtime: PropTypes.string.isRequired,
  myMessage: PropTypes.bool,
};

export default ChatDate;
